var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbUpLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.24996H3.75V15.25H1.5C1.30109 15.25 1.11032 15.1709 0.96967 15.0303C0.829018 14.8896 0.75 14.6989 0.75 14.5V6.99996C0.75 6.80105 0.829018 6.61028 0.96967 6.46963C1.11032 6.32898 1.30109 6.24996 1.5 6.24996V6.24996ZM5.46975 5.28021L10.2697 0.480212C10.3335 0.416232 10.4183 0.377437 10.5084 0.37096C10.5985 0.364484 10.688 0.390762 10.7603 0.444962L11.4 0.924962C11.5777 1.05835 11.7119 1.24135 11.7857 1.4509C11.8595 1.66046 11.8696 1.88717 11.8148 2.10246L10.95 5.49996H15.75C16.1478 5.49996 16.5294 5.658 16.8107 5.9393C17.092 6.22061 17.25 6.60214 17.25 6.99996V8.57796C17.2502 8.77398 17.212 8.96814 17.1375 9.14946L14.8162 14.7857C14.7596 14.9231 14.6634 15.0406 14.5399 15.1233C14.4164 15.2059 14.2711 15.25 14.1225 15.25H6C5.80109 15.25 5.61032 15.1709 5.46967 15.0303C5.32902 14.8896 5.25 14.6989 5.25 14.5V5.81046C5.25004 5.61157 5.32909 5.42083 5.46975 5.28021Z",
    fill: "#008080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpLine);
export default __webpack_public_path__ + "static/media/thumb-up-line.1e4c0990dd9ad59fd79ef8b22caa8c6e.svg";
export { ForwardRef as ReactComponent };